<template>
  <div class="custom-list-wraper">
    <bar-card>
      <sky-tabs v-model="tabValue"
                :tabList="tabList"
                @changeTab="changeTab">
        <el-popover style="margin-left:30px"
                    placement="top-start"
                    trigger="hover">
          <div style="line-height:30px">
            <p> 活跃：正常监测中的客户</p>
            非活跃：
            <ol>
              <li>1、待激活：谷歌CID已录入系统，但未设置KPI的客户</li>
              <li>2、暂停：账户长时间无消耗且余额不为0的客户</li>
              <li>3、死亡：账户长时间无消耗且余额为0的客户</li>
            </ol>
            <p> 注意：由活跃自动转入暂停或死亡的时间为预警规则中设置的时间+7天</p>
          </div>
          <i class="iconfont icon-tishi"
             style="cursor:pointer"
             slot="reference"></i>
        </el-popover>
      </sky-tabs>
      <div style="margin-right:20px;">
        数据截止：
        {{initDate.startDate}}
      </div>
    </bar-card>
    <keep-alive>
      <component :is="activeName"
                 :groups="groups"
                 :initDate="initDate"></component>
    </keep-alive>
  </div>
</template>

<script>
import filterPanel from "@/components/iglobalwin/filterPanelNew/filterPanel";
import barCard from "@/components/customPageCard/barCard";
import skyTabs from "@/components/iglobalwin/formComponents/tabs/sky-tabs.vue";
import active from "./activeList";
import inactive from "./inactiveList";
import { getDateList } from "@/common/util.js";
import userSearch from "@/components/tools/userSearch";
import { GetMonthStr } from "@/utils/index.js";
import skySelect from "@/components/iglobalwin/formComponents/sky-select.vue";
import { mapGetters } from 'vuex'

export default {
  name: "AdsMonitoringList",
  components: {
    barCard,
    skyTabs,
    filterPanel,
    active,
    inactive
  },
  data () {
    const dateList = getDateList(2);
    const endDate = dateList[1].value;
    const startDate = endDate;
    return {
      tabValue: "active",
      activeName: "active",
      initDate: {
        endDate,
        startDate,
      },
      tabList: [
        {
          label: "活跃",
          name: "active"
        },
        {
          label: "非活跃",
          name: "inactive"
        }
      ],
      multiples: [
        {
          defaultText: "子状态",
          placeholder: "子状态",
          label: "子状态",
          prop: "activeStatus",
          value: "0",
          options: [
            {
              label: "待激活",
              value: "0"
            },
            {
              label: "暂停",
              value: "2"
            },
            {
              label: "死亡",
              value: "3"
            }
          ]
        }
      ],
      groups: {
        others: [
          {
            tagName: "sky-input",
            placeholder: "订单号",
            label: "订单号",
            prop: "orderCode",
            value: null,
            emptyValue: null //删除tag时给value赋的值
          },
          {
            tagName: "sky-input",
            placeholder: "服务单号",
            label: "服务单号",
            prop: "serviceCode",
            value: null,
            emptyValue: null
          },
          {
            tagName: "sky-input",
            placeholder: "CID",
            label: "CID",
            prop: "cid",
            value: null,
            emptyValue: null
          },
          {
            tagName: userSearch,
            placeholder: "服务人员",
            label: "服务人员",
            prop: "serviceStaffId",
            value: null,
            emptyValue: null
          },
          {
            tagName: "sky-date-picker-prepend",
            type: "daterange",
            label: "日期",
            startPlaceholder: "开始日期",
            endPlaceholder: "结束日期",
            prop: ["startDate", "endDate", 'timeType'],
            value: [startDate, endDate, null],
            emptyValue: null,
            "picker-options": {
              disabledDate (time) {
                let date = GetMonthStr(3, "day");
                let start = new Date(date.now).getTime() - 24 * 3600 * 1000;
                return time.getTime() > start;
              }
            },
            prepend: {
              type: skySelect,
              options: [],
              style: {
                width: "230px"
              }
            }
          }
        ],
        multiples: []
      }
    };
  },
  methods: {
    changeTab (tab) {
      this.activeName = tab.name;
    }
  },
  watch: {
    activeName: {
      handler (val) {
        const baseOption = [
          {
            label: "消耗数据",
            value: null
          },
          {
            label: "CID绑定时间",
            value: "1"
          }
        ];
        if (val == "active") {
          this.groups.others[4].prepend.options = _.cloneDeep(baseOption);
        } else {
          this.groups.others[4].prepend.options = [
            ...baseOption,
            {
              label: "暂停时间",
              value: "2"
            },
            {
              label: "死亡时间",
              value: "3"
            }
          ];
          this.groups.multiples = _.cloneDeep(this.multiples);
        }
      },
      immediate: true,
      deep: true
    },
  },
  computed: {
    ...mapGetters(['userId'])
  },
  mounted () {

  }
};
</script>

<style></style>
